<script lang="ts">
  import type { CrawlerSource } from '../../modules/crawler/crawler-source.interface';
  import { Card, CardTitle, CardSubtitle } from 'svelte-materialify';

  export let crawlerSource: CrawlerSource;
  export let className: string;
</script>

{#if crawlerSource}
  <Card class="ps-card {className}">
    <div class="ps-img">
      <img src={crawlerSource.iconSVG || crawlerSource.icon} alt={crawlerSource.title} />
    </div>
    <div class="ps-details">
      <CardTitle>{crawlerSource.title}</CardTitle>
      <CardSubtitle>{crawlerSource.description || ''}</CardSubtitle>
      <span class="ps-type text-caption">{crawlerSource.contentType || ''}</span>
    </div>
  </Card>
{/if}

<style lang="scss">
  :global(.ps-card) {
    position: relative;
    display: flex !important;
    height: 108px;
    width: 430px;
    margin: 13px 12px;
    opacity: 1;
    cursor: pointer;
  }

  :global(.ps-card.single) {
    margin-left: 0;
    margin-bottom: 24px;
    cursor: auto;
    width: 100%;
  }

  :global(.ps-card.not-selected) {
    opacity: 0.4;
    box-shadow: none !important;
  }

  :global(.ps-card.selected) {
    border: solid 1px rgba(84, 28, 214, 0.9);
    margin: 12px;
  }

  .ps-img {
    flex: 0 0 108px;
    display: flex;
    align-items: center;
    overflow: hidden;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: inherit;

    img {
      width: 100%;
    }
  }

  .ps-details {
    flex: 1;
    position: relative;

    .ps-type {
      position: absolute;
      right: 13px;
      top: 7px;
      opacity: 0.5;
    }
  }
</style>
